import { Routes } from '@angular/router';
import { roleGuard } from './core/guards/role.guard';
import * as ROLE from './core/constants/roles.contants';

export const APP_ROUTES: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'home',
        loadChildren: async () => await import('./home/home.routes').then((m) => m.HOME_ROUTES),
    },
    {
        path: 'user-manager',
        loadChildren: async () =>
            await import('./user-manager/user-manager.routes').then((m) => m.USER_MANAGER_ROUTES),
        canActivate: [roleGuard],
        data: { allowedRoles: [ROLE.ROLE_ADMINISTRATOR] },
    },
    {
        path: 'budgets',
        loadChildren: async () => await import('./budgets/budgets.routes').then((m) => m.BUDGETS_ROUTES),
    },
    { path: '**', redirectTo: 'home', pathMatch: 'full' },
];
